import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Card } from './ui/card';
import { companyInfo } from '../data/mock';
import { Phone, MapPin, MessageCircle, Send, Clock } from 'lucide-react';
import { toast } from 'sonner';
export const API_URL = process.env.REACT_APP_API_URL;

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

    try {

    await new Promise((resolve) => setTimeout(resolve, 1000));

    const message = `Hola, soy ${formData.name}.%0A%0AEmail: ${formData.email}%0ATeléfono: ${formData.phone}%0A%0AMensaje: ${formData.message}`;
    window.open(`https://wa.me/${companyInfo.whatsapp}?text=${message}`, '_blank');

    toast.success('¡Mensaje enviado correctamente!');

    setFormData({
      name: '',
      email: '',
      phone: '',
      message: '',
    });

  } catch (error) {
    console.error(error);
    toast.error('No se pudo enviar el mensaje. Intenta nuevamente.');
  } finally {
    setIsSubmitting(false);
  }
};


  const contactInfo = [
    {
      icon: Phone,
      title: 'Teléfonos',
      content: `${companyInfo.phone1} / ${companyInfo.phone2}`,
      link: `tel:${companyInfo.phone1}`,
    },
    {
      icon: MessageCircle,
      title: 'WhatsApp',
      content: companyInfo.phone1,
      link: `https://wa.me/${companyInfo.whatsapp}`,
    },
    {
      icon: MapPin,
      title: 'Ubicación',
      content: companyInfo.address,
      link: '#',
    },
    {
      icon: Clock,
      title: 'Horario',
      content: 'Lun - Sáb: 9:00 AM - 7:00 PM',
      link: '#',
    },
  ];

  return (
    <section id="contacto" data-testid="contact-section" className="py-24 sm:py-32 bg-[#0F0F0F]">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left Side - Info */}
          <div>
            <span className="inline-block text-[#D4A520] font-medium text-sm uppercase tracking-[0.2em] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Contacto
            </span>
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-5 tracking-tight">
              ¿Listo para encontrar tu hogar ideal?
            </h2>
            <div className="w-16 h-[1px] bg-[#D4A520] mb-6" />
            <p className="text-white/50 text-base mb-10" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Contáctanos y un asesor especializado te ayudará a encontrar la propiedad perfecta para ti.
            </p>

            {/* Contact Cards */}
            <div className="grid sm:grid-cols-2 gap-4 mb-10">
              {contactInfo.map((info, index) => (
                <a
                  key={index}
                  href={info.link}
                  target={info.link.startsWith('http') ? '_blank' : '_self'}
                  rel="noopener noreferrer"
                  className="group"
                  data-testid={`contact-info-${index}`}
                >
                  <Card className="p-4 bg-[#1A1A1A] border border-[#D4A520]/10 rounded-none hover:border-[#D4A520]/40 transition-all duration-300">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 border border-[#D4A520]/20 flex items-center justify-center group-hover:bg-[#D4A520]/10 transition-colors duration-300">
                        <info.icon className="w-6 h-6 text-[#D4A520]" />
                      </div>
                      <div>
                        <div className="text-xs text-white/30 uppercase tracking-wider" style={{ fontFamily: 'Outfit, sans-serif' }}>{info.title}</div>
                        <div className="font-semibold text-white text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>{info.content}</div>
                      </div>
                    </div>
                  </Card>
                </a>
              ))}
            </div>

            {/* WhatsApp CTA */}
            <a
              href={`https://wa.me/${companyInfo.whatsapp}?text=Hola, me interesa conocer más sobre sus propiedades`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-cta"
              className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#20BA5A] text-white font-semibold px-8 py-4 rounded-none transition-all duration-300 hover:shadow-xl hover:shadow-[#25D366]/20 uppercase tracking-wider text-sm"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              <MessageCircle className="w-5 h-5" />
              Chatea por WhatsApp
            </a>
          </div>

          {/* Right Side - Form */}
          <Card className="p-8 bg-[#1A1A1A] rounded-none border border-[#D4A520]/10" data-testid="contact-form">
            <h3 className="text-2xl font-semibold text-white mb-8">
              Envíanos un mensaje
            </h3>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-xs font-medium text-white/40 mb-2 uppercase tracking-wider" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  Nombre completo
                </label>
                <Input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Tu nombre"
                  required
                  data-testid="contact-input-name"
                  className="w-full px-4 py-3 rounded-none bg-[#0A0A0A] border-[#D4A520]/10 text-white placeholder:text-white/20 focus:border-[#D4A520] focus:ring-[#D4A520]/20"
                />
              </div>
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-white/40 mb-2 uppercase tracking-wider" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Email
                  </label>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="tu@email.com"
                    required
                    data-testid="contact-input-email"
                    className="w-full px-4 py-3 rounded-none bg-[#0A0A0A] border-[#D4A520]/10 text-white placeholder:text-white/20 focus:border-[#D4A520] focus:ring-[#D4A520]/20"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-white/40 mb-2 uppercase tracking-wider" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Teléfono
                  </label>
                  <Input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+51 999 999 999"
                    required
                    data-testid="contact-input-phone"
                    className="w-full px-4 py-3 rounded-none bg-[#0A0A0A] border-[#D4A520]/10 text-white placeholder:text-white/20 focus:border-[#D4A520] focus:ring-[#D4A520]/20"
                  />
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-white/40 mb-2 uppercase tracking-wider" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  Mensaje
                </label>
                <Textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Cuéntanos qué tipo de propiedad buscas..."
                  required
                  rows={4}
                  data-testid="contact-input-message"
                  className="w-full px-4 py-3 rounded-none bg-[#0A0A0A] border-[#D4A520]/10 text-white placeholder:text-white/20 focus:border-[#D4A520] focus:ring-[#D4A520]/20 resize-none"
                />
              </div>
              <Button
                type="submit"
                disabled={isSubmitting}
                data-testid="contact-form-submit"
                className="w-full bg-[#D4A520] hover:bg-[#FFD700] text-black font-semibold py-6 rounded-none transition-all duration-300 hover:shadow-lg hover:shadow-[#D4A520]/20 disabled:opacity-50 uppercase tracking-wider hover:-translate-y-[2px]"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                {isSubmitting ? (
                  'Enviando...'
                ) : (
                  <>
                    <Send className="w-5 h-5 mr-2" />
                    Enviar Mensaje
                  </>
                )}
              </Button>
            </form>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
